var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 7.5H15C15 5.29 13.21 3.5 11 3.5C8.79 3.5 7 5.29 7 7.5H5C3.9 7.5 3 8.4 3 9.5V21.5C3 22.6 3.9 23.5 5 23.5H17C18.1 23.5 19 22.6 19 21.5V9.5C19 8.4 18.1 7.5 17 7.5ZM11 5.5C12.1 5.5 13 6.4 13 7.5H9C9 6.4 9.9 5.5 11 5.5ZM17 21.5H5V9.5H7V11.5C7 12.05 7.45 12.5 8 12.5C8.55 12.5 9 12.05 9 11.5V9.5H13V11.5C13 12.05 13.45 12.5 14 12.5C14.55 12.5 15 12.05 15 11.5V9.5H17V21.5Z",
    fill: "#D9059E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2 2.8H26V4.2H23.2V7H21.8V4.2H19V2.8H21.8V0H23.2V2.8Z",
    fill: "#D9059E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddItem);
export default __webpack_public_path__ + "static/media/addItem.d3a1c1a7cb56c81011428173f10f1cea.svg";
export { ForwardRef as ReactComponent };